import { Link as NavLink, useParams } from "react-router";

import Avatar from "@/design/components/Avatar";

import { Box, Link, Typography } from "@mui/material";
import PropTypes from "prop-types";

function MemberItemMini({ member, group }) {
  const { pbxId } = useParams();

  return (
    <Box
      sx={(theme) => ({
        borderRadius: 1,
        display: "grid",
        gridTemplateColumns: "subgrid",
        gridColumn: "1 / -1",
        alignItems: "center",
        gap: 1,
        px: 1.75,
        py: 0.875,
        "&:nth-of-type(even)": {
          backgroundColor: "#f8f8f8",
          ...theme.applyStyles("dark", {
            backgroundColor: "#28282d",
          }),
        },
        "&:hover": {
          backgroundColor: "#efefef",
          ...theme.applyStyles("dark", {
            backgroundColor: "#323237",
          }),
        },
      })}
    >
      {group.type === "LinearGroup" && (
        <Typography variant="body2" sx={{ textAlign: "end" }}>
          {member.position}
        </Typography>
      )}
      <Avatar text={member.sippeer.name} px={24} />
      <Typography variant="body2">
        <Link
          component={NavLink}
          to={`/pbx/${pbxId}/call-flow/${member.sippeer.username.startsWith("+") ? "mobile-users" : "users"}/${member.sippeer.id}`}
          sx={{ color: "inherit" }}
          underline="hover"
        >
          {member.sippeer.name}
        </Link>
      </Typography>
      <Typography
        variant="body2"
        sx={[group.type !== "LinearGroup" && group.callRecording !== "undefined" && { textAlign: "end" }]}
      >
        {member.sippeer.exten}
      </Typography>
      {group.callRecording === "undefined" && (
        <Typography variant="body2">
          {member.sippeer.callRecording === "OFF"
            ? "Off"
            : member.sippeer.callRecording === "INCOMING"
              ? "Incoming"
              : member.sippeer.callRecording === "OUTGOING"
                ? "Outgoing"
                : "On"}
        </Typography>
      )}
      {group.type === "LinearGroup" && (
        <Typography variant="body2" sx={{ textAlign: "end" }}>{`${member.ringSeconds} s`}</Typography>
      )}
    </Box>
  );
}

MemberItemMini.propTypes = {
  member: PropTypes.object,
  group: PropTypes.object,
};

export default MemberItemMini;
